export { default as IconNew } from './components/icon-new';
export { sizeMap as size, sizes } from './constants';
export { default as Skeleton } from './components/skeleton';
export { default as IconTile } from './components/icon-tile';

export type {
	Size,
	IconSize,
	SkeletonProps,
	IconProps,
	GlyphProps,
	CustomGlyphProps,
	SVGProps,
	NewIconProps,
	NewCoreIconProps,
	IconTileProps,
} from './types';
